import React from 'react';
import moment from 'moment';
import styles from 'LearningManager/styles/CustomSetup.module.scss';

interface ConfigureState {
	assignmentName: string;
	certDuration: string;
	certExpirationDate: string;
	assignmentStart: string;
	assignmentStartDate: string;
	dueDate: string;
	dueDateValue: string;
}

interface ConfigureSettingsCardProps {
	configure: ConfigureState;
}

const formatChoice = (value: string) => {
	if (!value) return '-';

	const map: Record<string, string> = {
		'one-year': 'One year',
		custom: 'Custom expiration',
		never: 'Never expires',
		immediate: 'Immediate',
		schedule: 'Schedule',
		none: 'None',
		'one-time-assignment': 'One-Time Assignment',
		'ongoing-assignment': 'Ongoing Assignment'
	};

	return map[value] ?? value;
};

const formatDate = (value: string) => {
	const parsed = moment(value);
	return parsed.isValid() ? parsed.format('MM/DD/YYYY') : value;
};

// Show the picked date for date-backed choices; otherwise the choice label.
const displayValue = (choice: string, isDateChoice: boolean, date: string) =>
	isDateChoice && date ? formatDate(date) : formatChoice(choice);

const ConfigureSettingsCard: React.FC<ConfigureSettingsCardProps> = ({
	configure
}) => {
	return (
		<div className={styles.summaryCard}>
			<div>
				<div className={styles.mutedLabel}>Name</div>
				<div className={styles.summaryValue}>
					{configure.assignmentName || '-'}
				</div>
			</div>

			<div className={styles.summaryGrid}>
				<div>
					<div className={styles.mutedLabel}>
						Certification Duration
					</div>
					<div className={styles.summaryValue}>
						{displayValue(
							configure.certDuration,
							configure.certDuration === 'custom',
							configure.certExpirationDate
						)}
					</div>
				</div>
				<div>
					<div className={styles.mutedLabel}>Assignment Start</div>
					<div className={styles.summaryValue}>
						{displayValue(
							configure.assignmentStart,
							configure.assignmentStart === 'schedule',
							configure.assignmentStartDate
						)}
					</div>
				</div>
				<div>
					<div className={styles.mutedLabel}>Due date</div>
					<div className={styles.summaryValue}>
						{displayValue(
							configure.dueDate,
							configure.dueDate === 'custom',
							configure.dueDateValue
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ConfigureSettingsCard;
